import { FC } from 'react'
import Box from '@mui/material/Box'
import ErrorResult from 'app/search/SearchDetails/SearchDetailsResults/ErrorResult'

interface ErrorProviderProps {
  errors: string[]
}

export const ErrorProvider: FC<ErrorProviderProps> = ({ errors }) => {
  if (!errors?.length) return null
  return (
    <Box width='100%'>
      {errors.map((errorKey, index) => (
        <ErrorResult key={index} error={errorKey} />
      ))}
    </Box>
  )
}
